export default __webpack_public_path__ + "static/media/sass.fb123914.svg";